<div class="form-horizontal">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  @if (!showFormLoader) {
<div>
    <h4>Batch List</h4>
    @if (batchRows.length > 0) {
<table class="table table-bordered custom-table">
      <thead>
        <tr>
          @for (col of batchColumns; track $index) {
<th>{{ col }}</th>
}
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (row of batchRows; track $index) {
<tr>
          @for (col of batchColumns; track $index) {
<td>{{ row[col] }}</td>
}
          <td><button class="reset-button" type="button" (click)="viewTransactions(row)">View Transactions</button></td>
        </tr>
}
      </tbody>
    </table>
}
    @if (batchRows.length === 0) {
<div>No batch records available.</div>
}
    <h4>Transactions</h4>
    @if (filteredTransactions.length > 0) {
<table class="table table-bordered custom-table">
      <thead><tr>@for (col of transactionColumns; track $index) {
<th>{{ col }}</th>
}</tr></thead>
      <tbody>@for (row of filteredTransactions; track $index) {
<tr>@for (col of transactionColumns; track $index) {
<td>{{ row[col] }}</td>
}</tr>
}</tbody>
    </table>
}
    @if (filteredTransactions.length === 0) {
<div>No transaction records available.</div>
}
  </div>
}
</div>
